module.exports = __webpack_public_path__ + "img/a34.b6f93d2c.jpg";